import TypedError from 'error/typed'
import rollbar from './rollbar/'
import isError from 'lodash/isError'

export const UndefinedError = TypedError({
  type: 'undefined',
  message: 'Exception or rejection value was null or undefined'
})

export const NotAnError = TypedError({
  type: 'not-an-error',
  message: 'Exception or rejection value was not an error object',
  value: null
})

export const ResponseDataError = TypedError({
  type: 'response-data-error',
  message: 'response data error'
})

export const SearchOfflineError = TypedError({
  type: 'search.offline',
  message: 'HTTP {statusCode} error, search offline',
  level: 'critical',
  statusCode: null
})

export const LandingPageNoContentError = TypedError({
  type: 'landing-page.no-content',
  level: 'warning',
  statusCode: 404,
  message: 'Content does not exist for landing page'
})

export const LandingPageUnpublishedError = TypedError({
  type: 'landing-page.unpublished',
  level: 'warning',
  statusCode: 404,
  message: 'Landing page is unpublished'
})

export const MetadataGenerationError = TypedError({
  type: 'metadata',
  title: 'Metadata',
  message: '{title}: {origMessage}'
})

export const MetadataGenerationWarning = TypedError({
  type: 'metadata',
  title: 'Metadata',
  message: '{title}: {origMessage}',
  level: 'warning'
})

export const RedisClientWarning = TypedError({
  type: 'redis',
  title: 'Redis client',
  message: '{title}: {origMessage}',
  level: 'warning'
})

export const AxiosNetworkError = TypedError({
  type: 'axios.network',
  level: 'warning',
  message: 'Network Error'
})

export const AxiosTimeoutError = TypedError({
  type: 'axios.timeout',
  message: 'Request [{endpoint}] timed out',
  level: 'warning',
  endpoint: '',
  url: '',
  statusCode: null,
  code: null
})

export const AxiosError = TypedError({
  type: 'axios',
  message: 'Request [{endpoint}] failed with status code {statusCode}',
  endpoint: '',
  url: '',
  httpMethod: '',
  statusCode: null,
  statusText: '',
  responseData: null
})

/**
 * Log error to rollbar
 * @param {Error} error
 */
export const logError = (error) => {
  if (isError(error)) {
    const level = [400, 401, 403].includes(error.statusCode) ? 'warning' : error.level
    if (rollbar[level]) {
      rollbar[level](error.message, error)
    } else {
      rollbar.error(error.message, error)
    }

    return error
  } else {
    if (error) {
      return logError(NotAnError({value: error}))
    } else {
      return logError(UndefinedError())
    }
  }
}



// WEBPACK FOOTER //
// ./common/utils/errors.js